import React, { useEffect } from 'react';
import { useData } from '../../../contexts';
import {
  DataGrid,
  GridColDef,
  GridEventListener,
  GridPagination,
  GridPreferencePanelsValue,
  GridToolbar,
  GridToolbarContainer,
  gridFilterActiveItemsSelector,
  gridPageCountSelector,
  gridPaginatedVisibleSortedGridRowEntriesSelector,
  gridPreferencePanelStateSelector,
  useGridApiContext,
  useGridApiEventHandler,
  useGridApiRef,
  useGridSelector,
} from '@mui/x-data-grid';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import MuiPagination from '@mui/material/Pagination';
import { TablePaginationProps } from '@mui/material/TablePagination';

export const SitueringTable = (props: any) => {
  const {
    data,
    pathInteractieveTool,
    setHighlightedRow,
    tableHighlightedRow,
    setTableHighlightedRow,
  } = props;
  const {
    deltaColors,
    selectedGemeente,
    selectedBenchmarks,
    setRadarIdToHighlight,
    locale,
    interfaceColor,
    searchParams,
    setSearchParams,
    fillColorHighlight,
  } = useData();

  const IndicatorCol = (row) => {
    const ido = row.row.row.ido;
    const type = row?.row?.row?.survey === '1' ? 'survey' : 'register';
    const out =
      row?.row?.row?.ratio === '%'
        ? '(procent - ' + type + ')'
        : '(' +
          row?.row?.row?.eenheid +
          ' ' +
          row?.row?.row?.ratio +
          ' - ' +
          type +
          ')';

    return (
      <div
        style={{
          color:
            parseInt(row.row.id) === parseInt(tableHighlightedRow)
              ? fillColorHighlight
              : null,
          fontWeight:
            parseInt(row.row.id) === parseInt(tableHighlightedRow)
              ? 'bold'
              : 'initial',
        }}
      >
        <a
          style={{
            marginBottom: '2px',
            paddingLeft: '8px',
            color:
              parseInt(row.row.id) === parseInt(tableHighlightedRow)
                ? fillColorHighlight
                : null,
            fontWeight:
              parseInt(row.row.id) === parseInt(tableHighlightedRow)
                ? 'bold'
                : 'initial',
          }}
          title={row.row.row.indicator}
          onClick={() => onDeeplinkClick(ido)}
        >
          {row.row.value}
        </a>
        <p style={{ paddingLeft: '8px', opacity: 0.8 }}>{out}</p>
      </div>
    );
  };

  const columns: GridColDef[] = [
    {
      field: 'indicator',
      headerName: 'Indicator',
      width: 500,
      type: 'string',
      renderCell: (row: any) => {
        return <IndicatorCol row={row} />;
      },
    },

    {
      field: 'jaar',
      headerName: 'Jaar',

      width: 80,
      type: 'string',
      renderCell: (row: any) => (
        <p
          style={{
            color:
              parseInt(row.row.id) === parseInt(tableHighlightedRow)
                ? fillColorHighlight
                : null,
            fontWeight:
              parseInt(row.row.id) === parseInt(tableHighlightedRow)
                ? 'bold'
                : 'initial',
          }}
        >
          {row.row.jaar}
        </p>
      ),
    },

    {
      field: 'rank',
      headerName: (
        <p style={{ lineHeight: '16px', textAlign: 'end' }}>
          Gemeente
          <br />
          positie
        </p>
      ),
      width: 130,
      type: 'number',
      renderCell: (row: any) => {
        let out = row.value + '/' + row.row.rankTotaal;
        if (row.value === undefined || row.value === null || row.value === 0) {
          out = '-';
        }

        return (
          <p
            style={{
              color:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? fillColorHighlight
                  : null,
              fontWeight:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? 'bold'
                  : 'initial',
            }}
          >
            {out}
          </p>
        );
      },
    },

    {
      field: 'value',
      headerName: (
        <p style={{ lineHeight: '16px', textAlign: 'end' }}>
          Gemeente
          <br />
          waarde
        </p>
      ),
      width: 130,
      type: 'number',
      renderCell: (row: any) => {
        let out = '-';
        if (row.value !== undefined && row.value !== null) {
          if (locale.format(row.row.d3format) !== undefined) {
            out = locale.format(row.row.d3format)(row.value);
          } else {
            out = row.value;
          }
        }

        return (
          <p
            style={{
              color:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? fillColorHighlight
                  : null,
              fontWeight:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? 'bold'
                  : 'initial',
            }}
          >
            {out}
          </p>
        );
      },
    },

    {
      field: 'rankBench',
      headerName: (
        <p style={{ lineHeight: '16px', textAlign: 'end' }}>
          Benchmark
          <br />
          positie
        </p>
      ),
      width: 130,
      type: 'number',
      renderCell: (row: any) => {
        let out = row.value + '/' + row.row.rankTotaal;
        if (row.value === undefined || row.value === null || row.value === 0) {
          out = '-';
        }

        return (
          <p
            style={{
              color:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? fillColorHighlight
                  : null,
              fontWeight:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? 'bold'
                  : 'initial',
            }}
          >
            {out}
          </p>
        );
      },
    },

    {
      field: 'valueBench',
      headerName: (
        <p style={{ lineHeight: '16px', textAlign: 'end' }}>
          Benchmark
          <br />
          waarde
        </p>
      ),
      width: 130,
      type: 'number',
      renderCell: (row: any) => {
        let out = '-';
        if (row.value !== undefined && row.value !== null) {
          if (locale.format(row.row.d3format) !== undefined) {
            out = locale.format(row.row.d3format)(row.value);
          } else {
            out = row.value;
          }
        }

        return (
          <p
            style={{
              color:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? fillColorHighlight
                  : null,
              fontWeight:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? 'bold'
                  : 'initial',
            }}
          >
            {out}
          </p>
        );
      },
    },

    {
      field: 'valueMin',
      headerName: (
        <p style={{ lineHeight: '16px', textAlign: 'end' }}>
          Minimale
          <br />
          waarde
        </p>
      ),
      width: 130,
      type: 'number',
      renderCell: (row: any) => {
        let out = '-';
        if (row.value !== undefined && row.value !== null) {
          if (locale.format(row.row.d3format) !== undefined) {
            out = locale.format(row.row.d3format)(row.value);
          } else {
            out = row.value;
          }
        }

        return (
          <p
            style={{
              color:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? fillColorHighlight
                  : null,
              fontWeight:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? 'bold'
                  : 'initial',
            }}
          >
            {out}
          </p>
        );
      },
    },

    {
      field: 'valueMax',
      headerName: (
        <p style={{ lineHeight: '16px', textAlign: 'end' }}>
          Maximale
          <br />
          waarde
        </p>
      ),
      width: 130,
      type: 'number',
      renderCell: (row: any) => {
        let out = '-';
        if (row.value !== undefined && row.value !== null) {
          if (locale.format(row.row.d3format) !== undefined) {
            out = locale.format(row.row.d3format)(row.value);
          } else {
            out = row.value;
          }
        }

        return (
          <p
            style={{
              color:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? fillColorHighlight
                  : null,
              fontWeight:
                parseInt(row.row.id) === parseInt(tableHighlightedRow)
                  ? 'bold'
                  : 'initial',
            }}
          >
            {out}
          </p>
        );
      },
    },
  ];

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <MuiPagination
        color={'primary'}
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
      />
    );
  }

  function CustomPagination(props: any) {
    return (
      <div>
        <GridPagination
          style={{ position: 'relative', right: 0 }}
          ActionsComponent={Pagination}
          labelRowsPerPage={'Indicatoren per pagina'}
          labelDisplayedRows={function defaultLabelDisplayedRows({
            from,
            to,
            count,
          }) {
            return `${from}–${to} van ${
              count !== -1 ? count : `meer dan ${to}`
            }`;
          }}
          {...props}
        />
      </div>
    );
  }

  const onDeeplinkClick = (ido: string) => {
    const toRemove = window.location.href.split('/').pop();
    const trimmedUrl = window.location.href.replace('/' + toRemove, '');
    const url = `${trimmedUrl}${pathInteractieveTool}?gemeente=${selectedGemeente.ruimte}&indicator=${ido}`;

    window.open(url, '_blank');
  };

  const handleRowMouseEnter: GridEventListener<'rowMouseEnter'> = (
    params, // GridRowParams
    event, // MuiEvent<React.MouseEvent<HTMLElement>>
    details, // GridCallbackDetails
  ) => {
    setTableHighlightedRow(params.id);
    setHighlightedRow(params.id);
  };

  const handleRowMouseLeave: GridEventListener<'rowMouseEnter'> = (
    params, // GridRowParams
    event, // MuiEvent<React.MouseEvent<HTMLElement>>
    details, // GridCallbackDetails
  ) => {
    // setTableHighlightedRow(null);
    // setHighlightedRow(null);
  };

  const apiRef = useGridApiRef();

  useEffect(() => {
    if (tableHighlightedRow !== null) {
      const allRows = gridPaginatedVisibleSortedGridRowEntriesSelector(apiRef);

      const rowIndex = allRows.findIndex(
        (row) => parseInt(row.id) === parseInt(tableHighlightedRow),
      );

      setTimeout(() => {
        if (typeof apiRef.current.scrollToIndexes !== 'undefined') {
          apiRef.current.scrollToIndexes({ rowIndex });
        }
      }, 0);
    }
  }, [apiRef, tableHighlightedRow]);

  useEffect(() => {
    const unsubscribe = apiRef.current.subscribeEvent(
      'rowMouseEnter',
      handleRowMouseEnter,
    );

    return () => unsubscribe();
  }, [apiRef]);

  useEffect(() => {
    const unsubscribe = apiRef.current.subscribeEvent(
      'rowMouseLeave',
      handleRowMouseLeave,
    );

    return () => unsubscribe();
  }, [apiRef]);

  return (
    <DataGrid
      apiRef={apiRef}
      rows={data}
      columns={columns}
      rowHeight={60}
      disableColumnMenu
      disableRowSelectionOnClick
      disableColumnFilter
      disableColumnSelector
      disableDensitySelector
      slots={{
        toolbar: GridToolbar,
        pagination: CustomPagination,
      }}
      slotProps={{
        toolbar: {
          csvOptions: { disableToolbarButton: true },
          printOptions: { disableToolbarButton: true },
          showQuickFilter: true,
        },
      }}
      pagination
      pageSizeOptions={[25, 50, 100]}
      localeText={{
        toolbarQuickFilterPlaceholder: 'Zoek binnen je selectie',
        toolbarQuickFilterLabel: 'Zoek binnen je selectie',
        toolbarQuickFilterDeleteIconLabel: 'Wissen',
      }}
      sx={{
        boxShadow: 0,
        border: 0,

        backgroundColor: '#FFF',
        '& .MuiPagination-ul': {
          listStyleType: 'none',
          '& li': {
            float: 'left',
          },
        },

        '& .MuiButton-text': {
          fontSize: '1.3rem',
        },

        '& .MuiInputBase-root': {
          fontSize: '1.4rem',
        },

        '& .MuiTablePagination-selectLabel': {
          margin: '0',
        },
        '& .MuiTablePagination-displayedRows': {
          margin: '0',
        },
        '& .MuiDataGrid-columnHeader:focus': {
          outline: 'none',
        },

        '& .MuiDataGrid-cell': {
          py: '12px',
          borderBottom: 'none',
          whiteSpace: 'normal !important',
          wordWrap: 'break-word !important',

          // '&:hover': {
          //   color: 'primary.dark',
          //   textDecoration: 'underline',
          // },

          '&:focus': {
            outline: 'none',
          },
        },

        '& .MuiDataGrid-row': {
          cursor: 'pointer',
          borderBottom: '1px solid #EEE',
          // borderBottom: 'none',
          '&:hover': {
            backgroundColor: '#fff',
          },

          '&:focus': {
            outline: 'none',
          },
        },
        '& li .Mui-selected': {
          color: 'white',
          backgroundColor: interfaceColor,
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
          width: '0.8em',
          height: '0.8em',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
          background: '#555',
        },
        '& .MuiDataGrid-virtualScroller': {
          // scrollbarColor: 'red blue',
          scrollbarWidth: 'thin',
        },
      }}
    />
  );
};
